import { AlterResponse } from "../../models/AlterView";
import { View } from "../View";

export default class Q7 extends View {
    render() {
        return (
            <div className="Q7">
                <h2>La machine prend le contrôle sur :</h2>
                <hr />
                <div className="btn-group">
                    <button onClick={ () => this.props.onFinish(AlterResponse.SUBJECT_1) }>Le sujet féminin</button>
                    <button onClick={ () => this.props.onFinish(AlterResponse.SUBJECT_2) }>Le sujet masculin</button>
                </div>
            </div>
        );
    }
}
